// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v2.users.properties.RentalManagerUserPropertyGetFieldsV2WebApiHandler

import type { QueryOptions, UseMutationOptions, UseQueryOptions } from '@zg-rentals/react-query5';
import { useMutation, useQuery } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import type { Client } from '@zg-rentals/http-client';
import {
  RentalManagerUserPropertyGetFieldsV2WebApiHandler_getGeneratedFields,
  RentalManagerUserPropertyGetFieldsV2WebApiHandler_getGeneratedFields_Path,
  RentalManagerUserPropertyGetFieldsV2WebApiHandler_getPropertyFields,
} from '@zg-rentals/ts-rental-manager-api-client';

import type {
  UserPropertyGetFieldsResponseV2WebDto,
  UserPropertyGetFieldsResponseWebDto,
  UserPropertyGetFieldsV2RequestDto,
  UserPropertyGetGeneratedFieldsV2RequestDto,
} from '@zg-rentals/ts-rental-manager-api-client';

export type RentalManagerUserPropertyGetFieldsV2WebApiHandler_getGeneratedFields_Options = UseQueryOptions<
  UserPropertyGetFieldsResponseWebDto,
  unknown,
  UserPropertyGetFieldsResponseWebDto,
  readonly [string, UserPropertyGetGeneratedFieldsV2RequestDto]
>;

const RentalManagerUserPropertyGetFieldsV2WebApiHandler_getGeneratedFields_GetKey = (
  postData: UserPropertyGetGeneratedFieldsV2RequestDto,
) => [RentalManagerUserPropertyGetFieldsV2WebApiHandler_getGeneratedFields_Path, postData] as const;

export const RentalManagerUserPropertyGetFieldsV2WebApiHandler_getGeneratedFields_queryOptions = (
  postData: UserPropertyGetGeneratedFieldsV2RequestDto,
  { httpClient }: { httpClient?: Client } = {},
) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: RentalManagerUserPropertyGetFieldsV2WebApiHandler_getGeneratedFields_GetKey(postData),
    queryFn: () => RentalManagerUserPropertyGetFieldsV2WebApiHandler_getGeneratedFields(postData, httpClient),
  }) as const satisfies QueryOptions;

/**
 * Return the most recently AI-generated fields for a manual listing
 */
export const useRentalManagerUserPropertyGetFieldsV2WebApiHandler_getGeneratedFields = (
  postData: UserPropertyGetGeneratedFieldsV2RequestDto,
  {
    httpClient,
    ...options
  }: Omit<RentalManagerUserPropertyGetFieldsV2WebApiHandler_getGeneratedFields_Options, 'queryFn' | 'queryKey'> & {
    httpClient?: Client;
  } = {},
) => {
  return useQuery({
    ...RentalManagerUserPropertyGetFieldsV2WebApiHandler_getGeneratedFields_queryOptions(postData, { httpClient }),
    ...options,
  });
};
useRentalManagerUserPropertyGetFieldsV2WebApiHandler_getGeneratedFields.getKey =
  RentalManagerUserPropertyGetFieldsV2WebApiHandler_getGeneratedFields_GetKey;

export interface RentalManagerUserPropertyGetFieldsV2WebApiHandler_getPropertyFields_Args {
  postData: UserPropertyGetFieldsV2RequestDto;
}

export type RentalManagerUserPropertyGetFieldsV2WebApiHandler_getPropertyFields_Options = UseMutationOptions<
  UserPropertyGetFieldsResponseV2WebDto,
  unknown,
  RentalManagerUserPropertyGetFieldsV2WebApiHandler_getPropertyFields_Args
>;

/**
 * Infer rental property listing fields for an existing manual listing
 */
export const useRentalManagerUserPropertyGetFieldsV2WebApiHandler_getPropertyFields = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyGetFieldsV2WebApiHandler_getPropertyFields_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyGetFieldsV2WebApiHandler_getPropertyFields_Args) =>
      RentalManagerUserPropertyGetFieldsV2WebApiHandler_getPropertyFields(args.postData, httpClient),
  });
};
